import React, { createContext, useContext } from 'react'

// Types - no screen imports here to avoid circular dependency
export type CreationStackType =
  | 'note'
  | 'reminder'
  | 'keepContact'
  | 'scheduledMessage'
  | 'message'
  | 'notificationSettings'

export interface CreationStackStep {
  component: React.ComponentType<any>
  title: string
}

export interface CreationStack {
  type: CreationStackType
  steps: CreationStackStep[]
  currentStepIndex: number
  data: Record<string, any>
}

export interface CreationStackContextType {
  isVisible: boolean
  currentStack: CreationStack | null
  showCreationStack: (type: CreationStackType, initialData?: Record<string, any>, stepIndex?: number) => void
  hideCreationStack: () => void
  nextStep: () => void
  previousStep: () => void
  goToStep: (stepIndex: number) => void
  updateStackData: (data: Record<string, any>) => void
  resetStack: () => void
  completeStep: (stepData?: Record<string, any>) => void
  canGoBack: boolean
  canGoNext: boolean
  isLastStep: boolean
  isFirstStep: boolean
  isCreationStackEnabled: boolean
}

const defaultContextValue: CreationStackContextType = {
  isVisible: false,
  currentStack: null,
  showCreationStack: () => console.warn('CreationStackProvider not initialized'),
  hideCreationStack: () => console.warn('CreationStackProvider not initialized'),
  nextStep: () => console.warn('CreationStackProvider not initialized'),
  previousStep: () => console.warn('CreationStackProvider not initialized'),
  goToStep: () => console.warn('CreationStackProvider not initialized'),
  updateStackData: () => console.warn('CreationStackProvider not initialized'),
  resetStack: () => console.warn('CreationStackProvider not initialized'),
  completeStep: () => console.warn('CreationStackProvider not initialized'),
  canGoBack: false,
  canGoNext: false,
  isLastStep: false,
  isFirstStep: false,
  isCreationStackEnabled: false,
}

export const CreationStackContext = createContext<CreationStackContextType>(defaultContextValue)

export const useCreationStack = (): CreationStackContextType => {
  const context = useContext(CreationStackContext)
  return context
}
